import { Controller } from "@hotwired/stimulus"

const STYLES = ["white", "soft", "frosted", "naked"]

export default class extends Controller {
  static values = { url: String, logoId: String, style: String }

  async pick({ params: { style } }) {
    const body = new FormData()
    body.append("logo_style", style)

    const response = await fetch(this.urlValue, {
      method: "PATCH",
      body,
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "X-Requested-With": "XMLHttpRequest",
        Accept: "text/html"
      }
    })
    if (!response.ok) return

    const template = document.createElement("template")
    template.innerHTML = (await response.text()).trim()
    const picker = template.content.firstElementChild

    this.updateLogo(picker.dataset.securityLogoStylesStyleValue)
    this.element.replaceWith(picker)
  }

  updateLogo(style) {
    const logo = document.getElementById(this.logoIdValue)?.querySelector(".security-logo")
    if (!logo) return

    logo.classList.remove(...STYLES.map((name) => `security-logo--${name}`))
    logo.classList.add(`security-logo--${style}`)
  }
}
